import { takeLatest, put, call } from 'redux-saga/effects';

import {
  SEARCH_COURSES_LIST_GET,
  SEARCH_DOCUMENTS_LIST_GET,
  SEARCH_DOCUMENTS_EXPERT_LIST_GET,
  SEARCH_MODULES_LIST_GET,
  SEARCH_EVENTS_LIST_GET,
} from '../actions/search';
import { LOADER_OPEN, LOADER_CLOSE } from '../actions';
import search from '../../api/search';
import { COURSE_LIST_GET, MODULE_LIST_GET } from '../actions/courselist';
import { DOCUMENTS_LIST_GET } from '../actions/documents';
import { DOCUMENTS_EXPERT_LIST_GET } from '../actions/documentsExpert';
import { errorHandling } from '../../../utils/errors';

function* searchCourseListGet({
  title = '',
  filters = {},
  catalogPage = false,
}) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      is_module: false,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(search.courseListGet, {
      ...completeFilters,
      search_text: title,
    });
    if (catalogPage) {
      yield put({
        type: COURSE_LIST_GET._SUCCESS,
        data,
        pager,
      });
    } else yield put({ type: SEARCH_COURSES_LIST_GET._SUCCESS, data, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > search > searchCourseListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* searchCourseListGetWatch() {
  yield takeLatest(SEARCH_COURSES_LIST_GET._REQUEST, searchCourseListGet);
}

function* searchModuleListGet({
  title = '',
  filters = {},
  catalogPage = false,
}) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      is_module: true,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(search.courseListGet, {
      ...completeFilters,
      search_text: title,
    });
    if (catalogPage) {
      yield put({
        type: MODULE_LIST_GET._SUCCESS,
        data,
        pager,
      });
    } else yield put({ type: SEARCH_MODULES_LIST_GET._SUCCESS, data, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > search > searchModuleListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* searchModuleListGetWatch() {
  yield takeLatest(SEARCH_MODULES_LIST_GET._REQUEST, searchModuleListGet);
}

function* searchEventListGet({
  title = '',
  filters = {},
  catalogPage = false,
}) {
  try {
    yield put({ type: LOADER_OPEN });
    const { categoryType, categories } = filters;
    const completeFilters = {
      ...filters,
      is_module: false,
      single_categories:
        categoryType === 'single_categories' ? categories : undefined,
      parent_categories:
        categoryType === 'parent_categories' ? categories : undefined,
    };
    delete completeFilters?.categories;
    delete completeFilters?.categoryType;
    const { data: { data, pager } = {} } = yield call(search.courseListGet, {
      ...completeFilters,
      search_text: title,
      typology: 'event',
      approval_status: 'APPROVED',
    });
    if (catalogPage) {
      yield put({
        type: COURSE_LIST_GET._SUCCESS,
        data,
        pager,
      });
    } else yield put({ type: SEARCH_EVENTS_LIST_GET._SUCCESS, data, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > search > searchEventListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* searchEventListGetWatch() {
  yield takeLatest(SEARCH_EVENTS_LIST_GET._REQUEST, searchEventListGet);
}

function* searchDocumentListGet({
  title = '',
  filters = {},
  catalogPage = false,
}) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data, pager } = {} } = yield call(search.documentsListGet, {
      ...filters,
      search_text: title,
    });
    if (catalogPage) {
      yield put({
        type: DOCUMENTS_LIST_GET._SUCCESS,
        response: data,
        pager,
      });
    } else yield put({ type: SEARCH_DOCUMENTS_LIST_GET._SUCCESS, data, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > search > searchDocumentListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* searchDocumentListGetWatch() {
  yield takeLatest(SEARCH_DOCUMENTS_LIST_GET._REQUEST, searchDocumentListGet);
}

function* searchDocumentExpertListGet({
  title = '',
  filters = {},
  catalogPage = false,
}) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data, pager } = {} } = yield call(
      search.documentsExpertListGet,
      {
        ...filters,
        search_text: title,
      }
    );
    if (catalogPage) {
      yield put({
        type: DOCUMENTS_EXPERT_LIST_GET._SUCCESS,
        response: data,
        pager,
      });
    } else {
      yield put({
        type: SEARCH_DOCUMENTS_EXPERT_LIST_GET._SUCCESS,
        data,
        pager,
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > search > searchDocumentExpertListGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* searchDocumentExpertListGetWatch() {
  yield takeLatest(
    SEARCH_DOCUMENTS_EXPERT_LIST_GET._REQUEST,
    searchDocumentExpertListGet
  );
}

export default [
  searchCourseListGetWatch(),
  searchModuleListGetWatch(),
  searchEventListGetWatch(),
  searchDocumentListGetWatch(),
  searchDocumentExpertListGetWatch(),
];
